import OrganizationModel from "src/models/OrganizationModel";
import PrivateSerieModel from "src/models/PrivateSerieModel";
import UserModel from "src/models/UserModel";
import renderEmail from "src/utils/renderEmail";

interface LessonSeriesAssignmentInput {
  organization: OrganizationModel;
  instructor: UserModel;
  admin: UserModel;
  privateSerie: PrivateSerieModel;
}

interface LessonSeriesAssignmentEmailVars {
  adminEmail: string;
  adminFullName: string;
  firstName: string;
  organizationName: string;
  organizationUrl: string;
  studentNames: string;
  type: string;
}

const LessonSeriesAssignment = (vars: LessonSeriesAssignmentEmailVars) => ({
  type: `LessonSeriesAssignment`,
  subject: `Assigned: ${vars.type} Registration - ${vars.organizationName}`,
  html: `<p>${vars.firstName},</p>

<p>You have been assigned a ${vars.type.toLowerCase()} registration with ${
    vars.studentNames
  }. Please visit Captyn to manage this registration and scheduling details ASAP.</p>
<p><a href="${vars.organizationUrl}">${vars.organizationUrl}</a></p>
<p>If you have any questions, please contact me at <a href="mailto:${
    vars.adminEmail
  }">${vars.adminEmail}</a>.</p>

<p>Sincerely,<br />
${vars.adminFullName ? vars.adminFullName : vars.organizationName}
</p>`,
  sms: `${vars.firstName}, you've been assigned a registration with ${
    vars.studentNames
  }. Visit Captyn at ${vars.organizationUrl} ASAP.${
    vars.adminFullName ? ` Sent by ${vars.adminFullName}` : ""
  }`,
});

export default ({
  organization,
  instructor,
  admin,
  privateSerie,
}: LessonSeriesAssignmentInput) => {
  const template = LessonSeriesAssignment;

  const studentNames = privateSerie.roster.map((s) => {
    return `${s.firstName} ${s.lastName}`;
  });

  const variables = {
    adminEmail: admin ? admin.email : "",
    adminFullName: admin ? `${admin.firstName} ${admin.lastName}` : "",
    firstName: instructor.firstName,
    organizationName: organization.title,
    organizationUrl: `https://${organization.subdomain}.captyn.com/admin/custom-private-lessons/${privateSerie.id}`,
    studentNames: studentNames.join(" and "),
    type: privateSerie.offering.type,
  };

  const email = renderEmail<LessonSeriesAssignmentEmailVars>({
    template,
    variables,
  });

  return email;
};
